<mat-card class="product-purpose-mix-main-area">
    <div [ngStyle]="{ display: isDataLoaded && hasData ? 'block' : 'none' }">
        <div class="donut-chart-main-container">
            <div class="area-left">
                <div class="chart-area" id="{{ pageId + 'chart-top-left' }}"></div>
            </div>
            <div class="area-right">
                <div class="chart-area" id="{{ pageId + 'chart-top-right' }}"></div>
            </div>
        </div>
        <div class="donut-chart-main-container">
            <div class="area-left">
                <div class="chart-area" id="{{ pageId + 'chart-bot-left' }}"></div>
            </div>
            <div class="area-right">
                <div class="chart-area" id="{{ pageId + 'chart-bot-right' }}"></div>
            </div>
        </div>
    </div>
    <div class="product-purpose-mix-spinner" *ngIf="!isDataLoaded">
        <spin-loader [type]="'spinner'"></spin-loader>
    </div>
    <div id="product-purpose-mix-no-data" *ngIf="isDataLoaded && !hasData">
        <no-data-screen [noDataType]="noDataDonutChart"></no-data-screen>
    </div>
</mat-card>
